import React from 'react'; //eslint-disable-line no-unused-vars
import {Route, Redirect, Switch, matchPath} from 'react-router';
import {getPath} from '@epic-core/common';
import BlogWrapper from '../views/blog/BlogWrapper';
import ArticleWrapper from '../views/blog/ArticleWrapper';
import HomeView from '../views/home/HomeView';
import ContributorView from '../views/contributor/ContributorView';
import GameTutorialView from '../views/tutorial/GameTutorialView';
import GameTutorialDetailView from '../views/tutorial/GameTutorialDetailView';
import ModTutorialView from '../views/tutorial/ModTutorialView';
import ModTutorialDetailView from '../views/tutorial/ModTutorialDetailView';
import MapsView from '../views/maps/MapsView';
import CharactersView from '../views/characters/CharactersView';
import ProgressionView from '../views/progression/ProgressionView';
import GalleryView from '../views/gallery/GalleryView';
import DownloadView from '../views/download/DownloadView';
import PlayerCardView from '../views/stats/PlayerCardView';

import Error500 from '../views/error/Error500';
import Error404 from '../views/error/Error404';

const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}`;
    return (
        <Redirect to={redirectUrl} />
    );
};
const redirectHome = redirectLocale.bind(null, '/');


const getRoutes = function getRoutes() {
    const path = getPath();
    const routes = (
        <Switch>
            <Route exact path={`${path}:locale/`} component={HomeView} />
            <Route exact path={`${path}:locale/home`} render={redirectHome} />
            <Route exact path={`${path}:locale/blog`} component={BlogWrapper} />
            <Route path={`${path}:locale/blog/category/:category`} component={BlogWrapper} />
            <Route path={`${path}:locale/blog/:title`} component={ArticleWrapper} />
            <Route exact path={`${path}:locale/community-contributors`} component={ContributorView} />
            <Route exact path={`${path}:locale/tutorials`} component={ModTutorialView} />
            <Route exact path={`${path}:locale/tutorials/:title`} component={ModTutorialDetailView} />
            <Route exact path={`${path}:locale/tutorials-how-to-play-ut`} component={GameTutorialView} />
            <Route exact path={`${path}:locale/tutorials-how-to-play-ut/:title`} component={GameTutorialDetailView} />
            <Route exact path={`${path}:locale/maps`} component={MapsView} />
            <Route exact path={`${path}:locale/characters`} component={CharactersView} />
            <Route exact path={`${path}:locale/progression`} component={ProgressionView} />
            <Route exact path={`${path}:locale/unreal-tournament-logo-wallpaper-gallery`} component={GalleryView} />
            <Route exact path={`${path}:locale/download`} component={DownloadView} />
            <Route exact path={`${path}:locale/playerCard`} component={PlayerCardView} />
            <Route path={`${path}:locale/unexpectedError`} component={Error500} />
            <Route component={Error404} />
        </Switch>
    );
    return routes;
};

export default getRoutes;
